import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const productAndServiceApi = createApi({
    reducerPath: 'productServiceApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        sgbpandSGBSApplicationTaskList: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/SGBPandSGBSApplicationTaskList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBPTaskDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetSGBPTaskDetailsById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getDropDownsForProductsAndServices: builder.query({
            query: () => ({
                url: encryptQueryString('/ProductsAndServices/GetDropDownsForProductsAndServices'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMainContactPersonDropdownByCorporateMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetMainContactPersonDropdownByCorporateMemberId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMainContactPersonDetailsForSGBPByRepresentativeId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetMainContactPersonDetailsForSGBPByRepresentativeId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProductsListByProductInformationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetProductsListByProductInformationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addBrandModelByProductInformationId: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/AddBrandModelByProductInformationId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        editSGBPProductsDetailsById: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/EditSGBPProductsDetailsById',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteSGBPProductDetailsById: builder.mutation({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/DeleteSGBPProductDetailsById?id=${id}`),
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBSTaskDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/ProductsAndServices/GetSGBSTaskDetailsById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateViewSGBSApplicationForm: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/UpdateViewSGBSApplicationForm',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateSGBPMembershipApplication: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/UpdateSGBPMembershipApplication',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendClarificationForSGBPApplication: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/SendClarificationForSGBPApplication',
                method: 'POST',
                body: transformRequest(details, "update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCriteriaBySGBPApplicationId: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/GetCriteriaBySGBPApplicationId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        notifyOrApproveSGBPApplication: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/NotifyOrApproveSGBPApplication',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCriteriaBySGBSApplicationId: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/GetCriteriaBySGBSApplicationId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        notifyOrApproveSGBSApplication: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/NotifyOrApproveSGBSApplication',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        checkServiceForZCPService: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/CheckServiceForZCPService',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addAuditLogForProductAndServiceApplication: builder.mutation({
            query: (details) => ({
                url: '/ProductsAndServices/AddAuditLogForProductAndServiceApplication',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useSgbpandSGBSApplicationTaskListMutation,
    useLazyGetSGBPTaskDetailsByIdQuery,
    useLazyGetDropDownsForProductsAndServicesQuery,
    useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery,
    useLazyGetProductsListByProductInformationIdQuery,
    useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery,
    useAddBrandModelByProductInformationIdMutation,
    useEditSGBPProductsDetailsByIdMutation,
    useDeleteSGBPProductDetailsByIdMutation,
    useLazyGetSGBSTaskDetailsByIdQuery,
    useUpdateViewSGBSApplicationFormMutation,
    useUpdateSGBPMembershipApplicationMutation,
    useSendClarificationForSGBPApplicationMutation,
    useGetCriteriaBySGBPApplicationIdMutation,
    useNotifyOrApproveSGBPApplicationMutation,
    useGetCriteriaBySGBSApplicationIdMutation,
    useNotifyOrApproveSGBSApplicationMutation,
    useCheckServiceForZCPServiceMutation,
    useAddAuditLogForProductAndServiceApplicationMutation
} = productAndServiceApi;

export default productAndServiceApi;